import { graphql } from "../gql";

export const getReportTransfersQueryDoc = graphql(`
  query reportTransfers {
    reportTransfers {
      ...ReportTransferFragment
    }
  }
`);
